var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.8304L22.3125 16.7958",
    stroke: "url(#paint0_linear_1020_2143)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37821 6.39856H3.38588C2.70103 6.39856 2.14062 6.77144 2.14062 7.22712V14.3681C2.14062 14.8238 2.70103 15.1966 3.38588 15.1966H5.37821C6.06305 15.1966 6.62339 14.8238 6.62339 14.3681V7.22712C6.62339 6.77144 6.06305 6.39856 5.37821 6.39856Z",
    fill: "url(#paint1_linear_1020_2143)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2219 3.59851H11.2296C10.5447 3.59851 9.98438 3.97646 9.98438 4.43824V14.3565C9.98438 14.8182 10.5447 15.1962 11.2296 15.1962H13.2219C13.9067 15.1962 14.4671 14.8182 14.4671 14.3565V4.43824C14.4671 3.97646 13.9067 3.59851 13.2219 3.59851Z",
    fill: "url(#paint2_linear_1020_2143)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9098 0H18.6684C17.8979 0 17.2676 0.402335 17.2676 0.89408V14.3028C17.2676 14.7945 17.8979 15.1969 18.6684 15.1969H20.9098C21.6802 15.1969 22.3107 14.7945 22.3107 14.3028V0.89408C22.3107 0.402335 21.6802 0 20.9098 0Z",
    fill: "url(#paint3_linear_1020_2143)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1020_2143",
    x1: 1.642,
    y1: 8.74421,
    x2: 18.8034,
    y2: 35.5465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC62F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39D6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1020_2143",
    x1: 0.926441,
    y1: 1.12407,
    x2: 1.64774,
    y2: 30.0979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC62F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39D6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1020_2143",
    x1: 9.30218,
    y1: 4.17154,
    x2: 21.0517,
    y2: 20.0985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC62F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39D6C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1020_2143",
    x1: 19.7891,
    y1: 8.39904e-8,
    x2: 27.1997,
    y2: 21.1567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC62F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39D6C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.aaa537d12676c96807168e61dfc1f679.svg";
export { ForwardRef as ReactComponent };